"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ExtraLabelListPopover = require("./ExtraLabelListPopover");
Object.keys(_ExtraLabelListPopover).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExtraLabelListPopover[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ExtraLabelListPopover[key];
    }
  });
});